/** One quiet 36px list treatment for both Pinned and Browse. */
export const navigationRowClassName =
  'relative flex h-9 w-full min-w-0 items-center gap-2 rounded-control px-3 text-left text-body font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-focus';
